import styled from 'styled-components'

export const Switch = styled.div`
  height: 20px;
  width: 38px;

  input {
    display: none;
    width: 0;
    height: 0;

    &:checked + label {
      background-color: ${ (props) => props.theme.colors.hellgruen1 };
      border-color: ${ (props) => props.theme.colors.hellgruen1 };
    }

    &:checked + label .button {
      left: calc(100% - 2px);
      transform: translateX(-100%);
    }
  }

  label {
    overflow: hidden;
    -webkit-tap-highlight-color: transparent;
    position: relative;
    border-radius: 32px;
    background-color: ${ (props) => props.theme.colors.grau };
    border: 1px solid ${ (props) => props.theme.colors.grau2 };
    height: 20px;
    width: 38px;
    min-width: 38px;
    margin: 0;
    transition-property: background-color, border-color;
    transition-timing-function: ease;
    transition-duration: 150ms;
    appearance: none;
    font-size: 6px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .button {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      height: 14px;
      width: 14px;
      border-radius: 32px;
      transition: 0.2s;
      background: #fff;
      box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
    }
  }
`
